module.exports = {"url":["^/myAccount$","^/myAccount/$","^/myOrderList","^/myOnlineReturn","^/order","^/payment","^/Research","^/myAccount/profile.html","^/myAccount/integralFlow","^/myAccount/myMemberCard","^/myAccount/changeHistory","^/myAccount/returnList","^/myAccount/returnDetails","^/myAccount/offlineOrderList","^/restMyCard","^/onlineReturn","^/myAccount/myMessage","^/myAccount/invoiceList","^/myAccount/issueInvoice"],"user":["/v3/shopcart/shopcart/addToCartForSingleProduct","/v1/shopcart/reminder/saveArrivalReminderUserData"]}


//////////////////
// WEBPACK FOOTER
// ./configuration/configAuth.json
// module id = 170
// module chunks = 1